import React from 'react';
import Button from 'react-bootstrap/Button';
import { formatPhoneNumber } from '../format/PhoneNumber';
import { FacilityAnalogGatewayRow } from '../hooks/FacilityAnalogGateway';

export type ListProps = {
  rows: FacilityAnalogGatewayRow[];
  loading: boolean;
  onEdit(row: FacilityAnalogGatewayRow): void;
  onDelete(row: FacilityAnalogGatewayRow): void;
  onConfigure(row: FacilityAnalogGatewayRow): void;
};

export const List: React.FC<ListProps> = ({
  rows,
  loading,
  onEdit,
  onDelete,
  onConfigure,
}) => {
  return (
    <>
      {loading && rows.length === 0 && (
        <p className="text-muted">Loading…</p>
      )}
      {rows.length > 0 && (
        <table className="table table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th>Gateway</th>
              <th>IP Address</th>
              <th>SIP</th>
              <th>FXO Ports</th>
              <th>FXS Ports</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((data) => (
              <tr key={data.id ?? data.name}>
                <td>
                  {data.name}
                  <br />
                  {data.model}
                </td>
                <td>{data.ipAddress}</td>
                <td>
                  {data.sipAuthUsername != null && data.sipAuthUsername !== '' && (
                    <div>User: {data.sipAuthUsername}</div>
                  )}
                  {data.sipAuthPassword != null && data.sipAuthPassword !== '' && (
                    <div>Pass: {data.sipAuthPassword}</div>
                  )}
                </td>
                <td>
                  <strong>{data.fxoPorts.length} FXO Ports</strong>
                  {data.fxoPorts.map((port) => (
                    <div key={`${data.id}-fxo-${port.hardwarePort}-${port.name}`}>
                      {port.status !== 'Active' && (
                        <i className="fas fa-times-circle text-danger" />
                      )}
                      {port.status === 'Active' && (
                        <i className="fas fa-check-circle text-success" />
                      )}{' '}
                      {port.name}{' '}
                      {port.facilityNumber != null && (
                        <span>{formatPhoneNumber(port.facilityNumber.ani)}</span>
                      )}
                    </div>
                  ))}
                </td>
                <td>
                  <strong>{data.fxsPorts.length} FXS Ports</strong>
                  {data.fxsPorts.map((port) => (
                    <div key={`${data.id}-fxs-${port.hardwarePort}-${port.name}`}>
                      {port.status !== 'Active' && (
                        <i className="fas fa-times-circle text-danger" />
                      )}
                      {port.status === 'Active' && (
                        <i className="fas fa-check-circle text-success" />
                      )}{' '}
                      {port.name}{' '}
                      {port.station != null && <span>{port.station.name}</span>}
                    </div>
                  ))}
                </td>
                <td className="text-center text-nowrap">
                  <Button
                    type="button"
                    variant="secondary"
                    size="sm"
                    className="me-1"
                    title="Edit"
                    aria-label={`Edit gateway ${data.name}`}
                    onClick={() => onEdit(data)}>
                    <i className="fas fa-edit" />
                  </Button>
                  <Button
                    type="button"
                    variant="secondary"
                    size="sm"
                    className="me-1"
                    onClick={() => onConfigure(data)}>
                    Configure
                  </Button>
                  <Button
                    type="button"
                    variant="danger"
                    size="sm"
                    title="Delete"
                    aria-label={`Delete gateway ${data.name}`}
                    onClick={() => onDelete(data)}>
                    <i className="fas fa-trash-alt" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {!loading && rows.length === 0 && (
        <p className="text-muted">No analog gateways.</p>
      )}
    </>
  );
};
